import Vue from 'vue'
import VueRouter from 'vue-router'
//路由导航冗余报错（路由重复）
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

// 创建路由
export default new VueRouter({
  mode: "history",
  linkActiveClass: "active",
  linkExactActiveClass: "currentActive",
  routes: [
    {
      path: '',
      component: () => import('@/components/index'),
      redirect: '/',
      children: [
        {
          path: '/',
          name: 'Home',
          component: () => import('@/components/pages/home/home.vue'),
        },
        {
          path: '/product/',
          name: 'Product',
          component: () => import('@/components/pages/product/productnew'),
        },
        {
          path: '/large/:id',
          name: 'Large',
          component: () => import('@/components/pages/product/large'),
        },
        {
          path: '/hr/',
          name: 'Producthr',
          component: () => import('@/components/pages/product/producthr'),
        },
        {
          path: '/outsource/',
          name: 'Productoutsource',
          component: () => import('@/components/pages/product/productoutsource'),
        },
        {
          path: '/wecom/',
          name: 'Productwecom',
          component: () => import('@/components/pages/product/productwecom'),
        },
        {
          path: '/ecall/',
          name: 'Productecall',
          component: () => import('@/components/pages/product/productecall'),
        },
        {
          path: '/mobile/',
          name: 'Productmobile',
          component: () => import('@/components/pages/product/Productmobile'),
        },
        {
          path: '/ordering/',
          name: 'Productordering',
          component: () => import('@/components/pages/product/productordering'),
        },
        {
          path: '/price',
          name: 'price',
          component: () => import('@/components/pages/price/price'),
        },
        {
          path: '/learning',
          name: 'Learining',
          component: () => import('@/components/pages/learn/learning'),
        },
        {
          path: '/register',
          name: 'Register',
          component: () => import('@/components/pages/register/register.vue'),
        },
        {
          path: '/about',
          name: 'About',
          component: () => import('@/components/pages/about'),
        },
        {
          path: '/media',
          name: 'media',
          component: () => import('@/components/pages/about/media'),
        },
        {
          path: '/coverage/1',
          name: '/coverage/1',
          component: () => import('@/components/article/one/one')
        },
        {
          path: '/coverage/2',
          name: '/coverage/2',
          component: () => import('@/components/article/two/two')
        },
        {
          path: '/coverage/3',
          name: '/coverage/3',
          component: () => import('@/components/article/three/three')
        },
        {
          path: '/coverage/4',
          name: '/coverage/4',
          component: () => import('@/components/article/four/four')
        },
        {
          path: '/coverage/5',
          name: '/coverage/5',
          component: () => import('@/components/article/one/oneless')
        },
        {
          path: '/coverage/6',
          name: '/coverage/6',
          component: () => import('@/components/article/five/five')
        },
        {
          path: '/coverage/7',
          name: '/coverage/7',
          component: () => import('@/components/article/seven/seven')
        },
        {
          path: '/coverage/8',
          name: '/coverage/8',
          component: () => import('@/components/article/eight/eight')
        },
      ]
    },

    { path: '*', redirect: '/' },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js